module.exports = __webpack_public_path__ + "img/TestGo.e8deb45e.svg";